import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { Ticket } from "lucide-react";

export default function Join() {
  const { user, setUser, logout } = useAuth();
  const [code, setCode] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const navigate = useNavigate();

  const redeem = async (e) => {
    e.preventDefault();
    if (!code.trim()) return;
    setSubmitting(true);
    try {
      const { data } = await api.post("/invites/redeem", { code });
      setUser(data.user);
      toast.success("Welcome to the family!");
      navigate("/dashboard", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid code");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-cream flex items-center justify-center p-6">
      <div className="brut-card p-8 bg-white w-full max-w-md">
        <div className="w-12 h-12 bg-sunny border-2 border-black rounded-xl shadow-brut flex items-center justify-center mb-4">
          <Ticket strokeWidth={3} className="w-6 h-6" />
        </div>
        <h1 className="font-fredoka text-3xl font-bold">Got an invite code?</h1>
        <p className="mt-2 text-sm text-gray-700">
          Hi {user?.name}, enter the invite code your family admin gave you to join.
        </p>
        <form onSubmit={redeem} className="mt-6 space-y-4">
          <input
            data-testid="invite-code-input"
            className="brut-input w-full uppercase tracking-wider font-fredoka text-lg"
            placeholder="FAMILY2026"
            value={code}
            onChange={(e) => setCode(e.target.value.toUpperCase())}
          />
          <button data-testid="invite-redeem-btn" disabled={submitting} className="brut-btn w-full text-lg py-3">
            {submitting ? "Joining…" : "Join the family"}
          </button>
        </form>
        <button data-testid="join-logout-btn" onClick={logout} className="mt-4 text-sm underline">
          Not you? Sign out
        </button>
        <p className="mt-4 text-xs text-gray-600">
          Tip: the very first person to sign up becomes admin automatically and receives
          starting points. New members: ask them for a code.
        </p>
      </div>
    </div>
  );
}
